var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:_vm.classObject},[_c('input',{attrs:{"disabled":_vm.disabled,"name":_vm.name,"type":"checkbox"},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }